import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeaderChildAttributes } from './HeaderChildAttributes';
import { HeaderDescription } from './HeaderDescription';
import { HeaderEnumValues } from './HeaderEnumValues';
import { HeaderHeading } from './HeaderHeading';
export function HeaderListItem({ header }) {
    return (_jsxs("div", { className: "space-y-3", children: [_jsx(HeaderHeading, { header: header }), _jsx(HeaderDescription, { header: header }), _jsx(HeaderEnumValues, { header: header }), _jsx(HeaderChildAttributes, { header: header })] }));
}
